import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import QuotationRequest from "../../../domain/Transaction/QuotationRequest";
import QuotationService from "../../../services/Transaction/QuotationService";
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import BeneficiaryRequiredFieldsService from "../../../services/Beneficiary/BeneficiaryRequiredFieldsService";
import TransactionRequiredFieldsComponent from "../../../components/TransactionRequiredFieldsComponent";
import Beneficiary from "../../../domain/Beneficiary/Beneficiary";
import BeneficiaryService from "../../../services/Beneficiary/BeneficiaryService";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import {Card,CardBody, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ToastHelper from "../../../utils/ToastHelper";

class BeneficiaryEdit extends React.Component {

    constructor(props) {
        super(props);

        this.capturedFieldsRef = null;

        this.state = {
            beneficiary: this.props.beneficiary,
            beneficiaryCapturedFields: [],
            updatedBeneficiary: null,
            quotationRequest: null,
            quotationResponse: null,

            requiredFieldsValid: false,

            loading: true,
            showErrorModal: false,
            errors: []
        };

        this.requiredFieldsValid = this.requiredFieldsValid.bind(this);
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader();
        this.retrieveRequiredFields()
    }

    retrieveRequiredFields() {

        let quote;

        quote = QuotationRequest.create(
            this.state.beneficiary.countryId,
            this.state.beneficiary.payoutMethodId,
            this.state.beneficiary.payoutPartnerId,
            this.state.beneficiary.currencyId,
            this.state.beneficiary.quotationType,
            this.state.beneficiary.amount,
            this.props.registrationId
        );

        this.setState({
            quotationRequest: quote
        });

        let promiseArr = [];

        promiseArr.push(QuotationService.requestQuotation(quote));
        promiseArr.push(BeneficiaryRequiredFieldsService.retrieveBeneficiaryRequiredFields(this.state.beneficiary.id));

        Promise.all(promiseArr).then(response => {
            let quotationResponse = response[0];
            let capturedFields = response[1];

            if (quotationResponse["error-code"]) {
                this.newState = {
                    loading: false,
                    showErrorModal: true,
                    errors: quotationResponse
                };
            } else {
                this.newState = {
                    quotationResponse: quotationResponse,
                    beneficiaryCapturedFields: capturedFields
                }
            }

            this.setState({
                ...this.newState
            }, () => this.convertCapturedFieldsToMap())
        });
    }

    convertCapturedFieldsToMap() {

        let captureFieldsMap = {};

        this.state.beneficiaryCapturedFields.forEach(capturedField => {
            captureFieldsMap[capturedField.requiredFieldId] = capturedField.value
        });

        this.setState({
            beneficiaryCapturedFields: captureFieldsMap,
            loading: false
        })
    }

    requiredFieldsValid = isValid => {

        this.setState({
            requiredFieldsValid: isValid
        })
    };

    generateUpdatedBeneficiary() {

        let capturedFields = this.capturedFieldsRef.getValues();
        capturedFields = capturedFields["captured-fields"];

        let beneficiaryName = Beneficiary.generateBeneficiaryName(capturedFields);

        let updatedBeneficiary = Beneficiary.createUpdatedBeneficiary(this.state.beneficiary, beneficiaryName, this.state.quotationRequest, this.state.quotationResponse, capturedFields);

        this.setState({
            updatedBeneficiary: updatedBeneficiary,
            loading: true
        }, () => this.updateBeneficiary(updatedBeneficiary))
    }

    updateBeneficiary(updatedBeneficiary) {

        BeneficiaryService.updateBeneficiary(this.state.beneficiary.id, updatedBeneficiary).then(response => {
            if(response.id) {
                this.setState({
                    updatedBeneficiaryResponse: response
                }, () => this.props.goBack())
            }else{
                ToastHelper.formatError(response);
            }
        })

    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>

            {this.props.className === 'mobile' ? this.renderContent('mobile') : this.renderBrowserContent('browser')}

        </Fragment>

    }

    renderContent(className) {

        return <Fragment>

            {this.renderErrorModal(className)}

            <TransactionRequiredFieldsComponent
                registerRef={ref => {
                    this.capturedFieldsRef = ref
                }}
                className={className}
                requiredFields={this.state.quotationResponse["requiredFields"]}
                values={this.state.beneficiaryCapturedFields}
                isValid={this.requiredFieldsValid}
                saveBeneficiary={false}
                setHeader={() => this.props.setHeader("Beneficiary Details")}
            />

            {this.renderUpdateButton(className)}
            {this.renderBackButton(className)}

        </Fragment>

    }

    renderBrowserContent(className) {

        return <Fragment><Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            <CardBody>
            {this.renderContent(className)}
            </CardBody>
        </Card>
            <br />
        </Fragment>
    }

    renderUpdateButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => this.generateUpdatedBeneficiary()}
                disabled={!this.state.requiredFieldsValid}
            >Update
            </SFXButtonComponent>
        </div>
    }

    renderBackButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_grey_oval_button"}
                onClick={() => this.props.goBack()}
            >Back
            </SFXButtonComponent>
        </div>
    }

    renderErrorModal(className) {

        return <Modal isOpen={this.state.showErrorModal}>

            <ModalHeader className={className + "_modal_header"}>{this.state.errors["message"]}</ModalHeader>
            <ModalBody>{this.state.errors["errors"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false
                    })}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }

}

export default withRouter(BeneficiaryEdit);